module.exports = __webpack_public_path__ + "static/img/pagi.eb1a5f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/pagi.jpg
// module id = 3QWM
// module chunks = 6